import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { ReferralSection } from "@/components/ReferralSection";
import { Link2, Share2, ShoppingBag, Wallet } from "lucide-react";
import { trackPageView } from "@/utils/analytics";
import { captureReferral } from "@/utils/referral";

const STEPS = [
  { icon: Link2, title: "1. Crea tu enlace", text: "Escribe tu nombre y tu WhatsApp. Te damos un codigo unico." },
  { icon: Share2, title: "2. Compartelo", text: "Mandalo por WhatsApp a tus amigos, familia o grupos." },
  { icon: ShoppingBag, title: "3. Tu amigo compra", text: "Cuando nos escriba, su mensaje trae tu codigo automaticamente." },
  { icon: Wallet, title: "4. Cobras $50", text: "Por cada compra te pagamos $50 MXN. Sin limite." },
];

export default function ReferralPage() {
  useEffect(() => {
    captureReferral();
    trackPageView("referidos");
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="referral-page">
      <Navbar />

      <section className="pt-10 pb-4 px-4">
        <div className="max-w-3xl mx-auto">
          <nav className="text-sm text-[#A0A0A0] mb-6">
            <Link to="/" className="hover:text-[#00FF66] transition-colors">Inicio</Link>
            <span className="mx-2 text-white/20">/</span>
            <span className="text-white">Referidos</span>
          </nav>
          <h1 className="font-oswald text-4xl sm:text-5xl lg:text-6xl font-bold text-white uppercase tracking-wider leading-tight">
            Gana <span className="text-[#00FF66]">$50</span> por cada amigo que compre
          </h1>
          <p className="text-[#A0A0A0] text-base md:text-lg mt-4 max-w-xl">
            Es facil: comparte tu enlace, tu amigo compra y tu cobras. No necesitas comprar nada.
          </p>
        </div>
      </section>

      <ReferralSection />

      <section className="py-12 px-4" data-testid="referral-steps">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-oswald text-2xl sm:text-3xl font-bold text-white uppercase tracking-wider text-center mb-10">Como funciona</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {STEPS.map(({ icon: Icon, title, text }) => (
              <div key={title} className="glass-card p-6 flex gap-4" data-testid={`referral-step-${title[0]}`}>
                <div className="w-12 h-12 rounded-full bg-[#00FF66]/10 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-6 h-6 text-[#00FF66]" />
                </div>
                <div>
                  <h3 className="font-oswald text-xl font-bold text-white">{title}</h3>
                  <p className="text-[#A0A0A0] text-base mt-1">{text}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="text-xs text-[#A0A0A0] text-center mt-8 max-w-lg mx-auto">
            El pago de $50 MXN se realiza por transferencia o en efectivo una vez confirmada la compra de tu referido. Ya tienes codigo? Abre tu enlace de ganancias desde la tarjeta de arriba.
          </p>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
